// export const mockClientItems = (itemsNumber = 100) => {
//   const mockItems = [];

//   for (let i = 1; i < itemsNumber + 1; i += 1) {
//     mockItems.push({
//       key: `${i}`,
//       FeederPillarName: "FP_01",
//       ConnectionType:
//         i === 2 ? "Cellular" : i === 3 ? "No Connectivity" : "LoraWAN",
//       Description: "Feeder Pillar",
//       FeederPillarCode: "FP1",
//       ApplicationKey: "FP_01",
//       ElectricityTariffRate: "E3",
//       DeviceToken: "FP_01",
//       Latitude: "1.5296967867267455",
//       Longitude: "110.36185711273917",
//       ElectricityTariff: "E3",
//     });
//   }
//   return mockItems;
// };

export const mockServerItems = async (serverOptions, items) => {
  const { page, rowsPerPage, sortBy, sortType } = serverOptions;
  // const serverItemsLength = 99;
  const serverItemsLength = items.length;

  // const serverTotalItems = mockClientItems(serverItemsLength);
  const serverTotalItems = items
  if (sortBy && sortType) {
    serverTotalItems.sort((a, b) => {
      if (a[sortBy] < b[sortBy]) return sortType === "desc" ? 1 : -1;
      if (a[sortBy] > b[sortBy]) return sortType === "desc" ? -1 : 1;
      return 0;
    });
  }
  await new Promise((s) => setTimeout(s, 2000));
  return {
    serverCurrentPageItems: serverTotalItems.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    ),
    serverTotalItemsLength: serverItemsLength,
  };
};
